/**
 * The store has the following format:
 * {
 *    embeddingType: {
 *      data: { nNodes, bounds, cellIds, xValues, yValues, subtreeEnd, childMask },
 *              // typed-array descriptor; null until loaded
 *      loading: false,
 *      error: false
 *    }
 * }
 *
 * The wire format is a packed little-endian binary structure-of-arrays payload
 * (see utils/embeddingQuadtree.js). fetchWork gunzips it and parseEmbeddingQuadtree
 * takes zero-copy typed-array views over it to build this descriptor before
 * anything hits the renderer.
 *
 * - cellIds[i]: uint32  representative cellId at node i (max cellId in subtree)
 * - xValues[i], yValues[i]: float32 coordinates of the representative cell
 * - subtreeEnd[i]: uint32 pre-order end index — the node's subtree occupies
 *     the contiguous slice cellIds[i .. subtreeEnd[i])
 * - childMask[i]: uint8 bitfield for children [nw, ne, sw, se]
 * - bounds: float32[4] root bounds [minX, minY, maxX, maxY]
 */

var initialEmbeddingState = {
  data: null,
  loading: true,
  error: false
};
var initialState = {};
export { initialEmbeddingState };
export default initialState;